import dynamic from "next/dynamic";
import DynamicGridConfig from "./dynamic-grid-config";
import DynamicGridAdvancedConfig from "./dynamic-grid-advanced-config";
const DynamicGridComponent = dynamic(()=>import("./dynamic-grid-component"));
export default {
    DynamicGridComponent,
    DynamicGridConfig,
    DynamicGridAdvancedConfig
};
